import { ComputedRef, InjectionKey, Ref } from 'vue'

export const ModalInjectionKey = Symbol() as InjectionKey<{
  close: () => void
  updateHeaderHeight: (height: number) => void
  updateFooterHeight: (height: number) => void
  contentMaxHeight: ComputedRef<string>
  contentMinHeight: ComputedRef<string>
}>
